import React, {useContext} from "react";
import {Container, Row, Col} from "react-bootstrap";
import ResponseToast from "components/ResponseToast";
import AssetTransferEntryResult from "./AssetTransferEntryResult";
import AssetTransferEntry from "./AssetTransferEntry";
import {AssetTransferContext} from "./context";
import {ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT} from "./context/AssetTransferContext";

export default function AssetTransferEntryPanel() {

    const {assetTransferCaptureDisplayState} = useContext(AssetTransferContext);

    const currentComponent = function () {

        if (assetTransferCaptureDisplayState && assetTransferCaptureDisplayState.currentPage === ASSET_TRANSFER_CAPTURE_PANEL_ENTRY_RESULT)
            return <AssetTransferEntryResult/>
        return <AssetTransferEntry/>
    }

    return(<>
        <Container fluid>
            <Row>
                <Col style={{padding:0}}>
                    {currentComponent()}
                </Col>
            </Row>
            <Row>
                <ResponseToast isFullWidth={true}/>
                <br/>
            </Row>
        </Container>
    </>);

}
